:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  /**
   * @prop --ch-action-menu-item__image-size:
   * Specifies the box size that contains the start or end images of the items.
   * @default 0.875em
   */
  --ch-action-menu-item__image-size: 0.875em;
  /**
   * @prop --ch-action-menu-item__background-image-size:
   * Specifies the size of the start and end images of the items.
   * @default 100%
   */
  --ch-action-menu-item__background-image-size: 100%;
  --ch-action-menu-separation: 0px;
  --ch-action-menu-separation-x: var(--ch-action-menu-separation);
  --ch-action-menu-separation-y: var(--ch-action-menu-separation);
  display: contents;
}

::slotted(action) {
  pointer-events: none;
}

hr {
  display: grid;
  block-size: 1px;
  margin: 0;
  background-color: color-mix(in srgb, currentColor 25%, transparent);
  border: unset;
  pointer-events: none;
}